import { PARTNER_NORMALIZATION_ISSUE_LABELS } from "./partnerNormalizationReviewConstants";

export const VEHICLE_IDENTITY_HEALTH_SCORE_LABELS = Object.freeze({
  excellent: "Excellent",
  good: "Good",
  needs_attention: "Needs attention",
  poor: "Poor",
});

export const VEHICLE_IDENTITY_ISSUE_SEVERITY_LABELS = Object.freeze({
  high: "High",
  medium: "Medium",
  low: "Low",
});

export function vehicleIdentityIssueLabel(issueType) {
  return PARTNER_NORMALIZATION_ISSUE_LABELS[issueType] || issueType;
}

export function formatCoveragePercent(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${Math.round(Number(value) * 100)}%`;
}

export function vehicleIdentityHealthScoreClass(score) {
  switch (score) {
    case "excellent":
      return "partner-vehicle-identity-health__score--excellent";
    case "good":
      return "partner-vehicle-identity-health__score--good";
    case "needs_attention":
      return "partner-vehicle-identity-health__score--attention";
    default:
      return "partner-vehicle-identity-health__score--poor";
  }
}
